(()=>{
  //sauce widget click
  let className =  'snptcrd--vid';
  if (window.location.pathname.includes('/products/')){
    let interval,
    counter = 0,
    duration = 250,
    limit = 40;
    interval = setInterval( () => {
      if (document.getElementsByClassName(className).length > 0){

      let sauceVidButtonArr = Array.from(document.getElementsByClassName(className));
      sauceVidButtonArr.forEach((el) => {
        el.addEventListener('click', () => {
          //console.log('sauce vid click');
          window.gtag('event', 'sauce_vid_click', {
            'location': window.location.href,
            'size': el.getElementsByClassName('snpt-annotation')[0].innerHTML.split('<br>')[0].replace('Size ', ''),
          });
        });
      });
        clearInterval( interval );
      } else if ( counter === limit ) {
        clearInterval ( interval );
      } 
    }, duration );
  }
})();

(()=>{
  //size video click
  let className =  'size-videos__btn';
  if (window.location.pathname.includes('/products/')){
    let interval,
    counter = 0,
    duration = 250,
    limit = 40;
    interval = setInterval( () => {
      if (document.getElementsByClassName(className).length > 0){

      let sauceVidButtonArr = Array.from(document.getElementsByClassName(className));
      sauceVidButtonArr.forEach((el) => {
        el.addEventListener('click', () => {
          //console.log('size vid click');
          window.gtag('event', 'size_vid_click', {
            'location': window.location.href,
            'size': el.dataset.size
          });
        });
      });
        clearInterval( interval );
      } else if ( counter === limit ) {
        clearInterval ( interval );
      } 
    }, duration );
  }
})();